module.exports = __webpack_public_path__ + "img/pethouse52.fb209929.jpg";